/**
 * Retrieves the value of a query string parameter given its key.
 *
 * @param {string} key The key of the query string parameter to retrieve.
 * @param {string} [queryString=window.location.search] The query string to parse. Defaults to the current window's search string.
 * @returns {string | null} The value of the query string parameter, or null if it's not found.
 */
export function getQueryParam(key, queryString = window.location.search) {
  // Remove the leading '?' if it exists
  const searchParams = new URLSearchParams(queryString.startsWith('?') ? queryString.slice(1) : queryString);
  return searchParams.get(key);
}

/**
 * Gets the value of a cookie
 *
 * @param {string} name The name of the cookie key to retrieve.
 * @returns {string | null} The value of the cookie key value pair, or null if the key is not found.
 */
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
  return null;
}